import { useEffect, useState } from "react";
import http from "@/lib/api";
import { Panel, fmt } from "./AdminKit";
import { AudioLines, MessageSquareText } from "lucide-react";

const AGENT_ID = process.env.REACT_APP_ELEVENLABS_AGENT_ID;
const CONN = {
  confirmed: ["Подтверждено реальным запросом", "bg-emerald-900/40 text-emerald-300 border-emerald-700/50"],
  errors: ["Есть ошибки, успешных запросов нет", "bg-red-900/40 text-red-300 border-red-700/50"],
  not_verified: ["Не проверено — ElevenLabs ещё не вызывал инструменты BKT", "bg-amber-900/40 text-amber-300 border-amber-700/50"],
};
const Row = ({ k, v, id }) => <div className="flex justify-between gap-4 py-1.5 border-b border-slate-700/50 text-sm"><span className="text-slate-400">{k}</span><span className="text-slate-200 text-right" data-testid={id}>{v}</span></div>;
const yes = (b) => (b ? "да" : "нет");
const call = (c) => (c ? `${c.tool} · ${c.ok ? "успешно" : "ошибка"} · ${fmt(c.at)}` : "—");

export default function AdminAgentSettings() {
  const [s, setS] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { http.get("/v1/admin/agent-status").then((r) => setS(r.data)).catch(() => setErr(true)); }, []);
  const [label, cls] = CONN[s?.elevenlabs_connection] || ["Статус недоступен", "bg-slate-700 text-slate-300 border-slate-600"];
  const auth = s?.voice_tools.auth_errors || {};
  return (
    <div className="space-y-6" data-testid="admin-agent-vadim">
      <h1 className="text-2xl font-bold text-white">AI-агент Vadim</h1>
      {err && <p className="text-red-400 text-sm" data-testid="agent-status-error">Не удалось получить статус.</p>}
      {s && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <Panel title={<span className="flex items-center gap-2"><MessageSquareText className="h-4 w-4" />Текстовый Vadim (веб-чат «Skriv»)</span>}>
            <Row k="AI-ключ настроен" v={yes(s.text_chat.llm_configured)} id="agent-text-llm" />
            <Row k="Последняя активность" v={s.text_chat.last_activity ? fmt(s.text_chat.last_activity) : "—"} id="agent-text-last" />
            <Row k="Чатов за 7 дней" v={s.text_chat.sessions_7d} id="agent-text-7d" />
            <p className="text-xs text-slate-500 mt-2">Использует цены, часы, базу знаний и временные объявления из этой админки при каждом сообщении.</p>
          </Panel>
          <Panel title={<span className="flex items-center gap-2"><AudioLines className="h-4 w-4" />Голосовой Vadim (ElevenLabs «Snakk»)</span>}>
            <div className="mb-3"><span className={`inline-block px-3 py-1 rounded-full text-xs border ${cls}`} data-testid="agent-voice-connection">Связь ElevenLabs ↔ BKT: {label}</span></div>
            <Row k="Виджет на сайте (ID агента)" v={AGENT_ID ? "настроен" : "нет"} id="agent-voice-widget" />
            <Row k="Секрет инструментов на сервере" v={yes(s.voice_tools.secret_configured)} id="agent-voice-secret" />
            <Row k="Инструментов BKT" v={s.voice_tools.tools.length} id="agent-voice-tools" />
            <Row k="Последний успешный запрос" v={call(s.voice_tools.last_success)} id="agent-voice-last-ok" />
            <Row k="Последний запрос" v={call(s.voice_tools.last_call)} id="agent-voice-last" />
            <Row k="Запросов / ошибок за 7 дней" v={`${s.voice_tools.calls_7d} / ${s.voice_tools.failed_7d}`} id="agent-voice-7d" />
            <Row k="Отклонённые запросы (неверный секрет)" v={auth.last_error_at ? `${auth.http_401 || 0} · последний ${fmt(auth.last_error_at)}` : "—"} id="agent-voice-auth" />
            <p className="text-xs text-slate-500 mt-2">«Подтверждено» появляется только после реального успешного вызова инструмента из ElevenLabs. Значения секретов не показываются.</p>
          </Panel>
        </div>
      )}
    </div>
  );
}
